/**
 * Object.hasOwn polyfill for older browsers
 * 实现 Object.hasOwn 的向下兼容
 */
if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: function (object: object, property: PropertyKey): boolean {
      if (object == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    },
    configurable: true,
    enumerable: false,
    writable: true,
  });
}

export {};
